import { appConfigMapping } from './app.config.mapping';

export const environment = {
  production: true,
  appConfig: appConfigMapping
};
